import React, { useState } from "react";
import { Link } from "react-router-dom";
import { submitZaehlerstand, updateZaehlerstand } from "../api";


function ZählerComponente({mieter, zaehler, refreshData }) {
  // Sort the readings by date in ascending order (oldest first)
  const sortedZaehlerstaende = [...zaehler.zaehlerstaende].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  // Get the latest entry
  const latestEntry = sortedZaehlerstaende[sortedZaehlerstaende.length - 1];
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // JavaScript months are 0-based

  // Check if last entry is from December but not the current year
  const shouldShowUpload =
    !latestEntry ||
    (new Date(latestEntry.date).getFullYear() !== currentYear &&
      new Date(latestEntry.date).getMonth() + 1 === 12 &&
      currentMonth === 12);

  // State for new reading inputs
  const [date, setDate] = useState(shouldShowUpload ? "" : latestEntry?.date || "");
  const [reading, setReading] = useState(shouldShowUpload ? "" : latestEntry?.reading || "");

  // Submit new entry
const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    await submitZaehlerstand(zaehler.id, date, reading);
    setDate("");
    setReading("");
    refreshData();
  } catch (error) {
    console.error("Error submitting data:", error);
    alert("Fehler beim Speichern der Daten.");
  }
};

// Update existing entry
const handleUpdate = async (event) => {
  event.preventDefault();
  try {
    await updateZaehlerstand(latestEntry.id, date, reading, zaehler.id);
    refreshData();
  } catch (error) {
    console.error("Error updating data:", error);
    alert("Fehler beim Aktualisieren der Daten.");
  }
};


  return (
<div className="zaehler-card" style={{ zpIndex: 5,}}>
  <h3 className="zaehler-title">
    {zaehler.description} (
    {mieter ? (
      <Link to={`zaehler/${zaehler.zaehlernummer}`} className="zaehler-link">
        {zaehler.zaehlernummer}
      </Link>
    ) : (
      <span>{zaehler.zaehlernummer}</span>
    )}
    )
  </h3>

  <ul className="zaehler-list">
    {sortedZaehlerstaende.map((entry) => (
      <li key={entry.id}>
        <strong>{entry.date}</strong>: {entry.reading} m³
        {entry.verbrauch !== null && ` (Verbrauch: ${entry.verbrauch.toFixed(3)})`}
      </li>
    ))}
  </ul>

  {mieter && (
    <form onSubmit={shouldShowUpload ? handleSubmit : handleUpdate} className="zaehler-form">
      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        required
        className="zaehler-input"
      />
      <input
        type="number"
        step="0.001"
        placeholder="Zählerstand"
        value={reading}
        onChange={(e) => setReading(e.target.value)}
        required
        className="zaehler-input"
      />
      <button type="submit" className="zaehler-button">
        {shouldShowUpload ? "Absenden" : "Aktualisieren"}
      </button>
    </form>
  )}
</div>

  )
}

export default ZählerComponente;
